import Swiper from 'swiper/dist/js/swiper.min';

export default new class SubscriptionVersions {
  constructor() {
    this.holderClass = '.subscription-versions';
    this.tabClass = '.subscription-versions__tab';
    this.tabActiveClass = '_active';
    this.sliderClass = '.subscription-versions__tabs-content';
    this.isMobile = document.body.classList.contains('mobile');
    this.URLHash = window.location.hash.slice(1)

    if (!document.querySelector(this.holderClass)) return;

    this.init();
  }

  init() {
    const holder = document.querySelector(this.holderClass);
    const tabs = holder.querySelectorAll(this.tabClass);
    const slider = holder.querySelector(this.sliderClass);
    const swiper = new Swiper(slider, {
      init: false,
      initialSlide: this.chooseSwiperInitialTab(tabs),
      spaceBetween: 50,
      simulateTouch: false,
      autoHeight: !!this.isMobile,
      on: {
        slideChange: () => {
          this.selectActiveTab(tabs, swiper.activeIndex);
        },
      },
    });
  
    swiper.init();

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        swiper.slideTo(index);
      });
    });
  }

  chooseSwiperInitialTab(tabs) {
    if (this.URLHash == "rz"|| this.URLHash == "gms" || this.URLHash == "site") {
      let activeTabIndex;
      tabs.forEach((tab, index) => {
        if (tab.classList.contains(`__${this.URLHash}`)) {
          tab.classList.add(this.tabActiveClass)
          history.pushState(null, null, `${window.location.pathname}`);
          activeTabIndex = index
        }
      });
      return activeTabIndex
    } else {
        tabs.forEach((tab, index) => {
          if (index === 0) tab.classList.add(this.tabActiveClass);
        });
      return 0
    } 
  }

  selectActiveTab(tabs, slideIndex) {
    tabs.forEach((tab, index) => {
      if (tab.classList.contains(this.tabActiveClass) && slideIndex !== index) {
        tab.classList.remove(this.tabActiveClass);
      }
      if (slideIndex === index) tab.classList.add(this.tabActiveClass);
    });
  }
}();
